import { render, staticRenderFns } from "./BankLoginPage.vue?vue&type=template&id=c78a1e46&"
import script from "./BankLoginPage.vue?vue&type=script&lang=js&"
export * from "./BankLoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports